import { env } from "@/config";
import { getSelectedSessionId } from "@/sdk";
import { getSharedApiClient } from "@/shared-utils";

export const getCustomerDetailsApi = () => {
    return getSharedApiClient(getSelectedSessionId()).extend(() => ({
        prefix: `${env.backendUrls.apiBaseUrl}/api/customer`,
    }));
};
